"use strict";
export const SVGNS = "http://www.w3.org/2000/svg";
export function el(name, attrs) {
  const e = document.createElementNS(SVGNS, name);
  for (const k in attrs) e.setAttribute(k, attrs[k]);
  return e;
}
export function round(v, d = 0) {
  const p = Math.pow(10, d);
  return Math.round(v * p) / p;
}
export function esc(s) {
  return String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
}
export function srTable(caption, headers, rows) {
  const th = headers.map((h) => `<th scope="col">${esc(h)}</th>`).join("");
  const body = rows.map(
    (r) => `<tr>${r.map((c, i) => i === 0 ? `<th scope="row">${esc(c)}</th>` : `<td>${esc(c)}</td>`).join("")}</tr>`
  ).join("");
  return `<table class="sr-only"><caption>${esc(caption)}</caption><thead><tr>${th}</tr></thead><tbody>${body}</tbody></table>`;
}
